import React from "react";

import { useIntl, FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";

import { AddButton } from "ds/Button";
import { Tooltip } from "ds/Tooltip";
import Illustration from "Vendor_resources/images/empty-projects-team.svg";
import IllustrationDark from "Vendor_resources/images/empty-projects-team_dark.svg";

import * as EmptyCards from "./components/EmptyTeamCards.styles";

type TeamsProjectsEmptyProps = {
  onAdd?: () => void;
  $alignTop?: boolean;
};

export const TeamProjectsEmpty = (props: TeamsProjectsEmptyProps) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <EmptyCards.Card $alignTop={props.$alignTop} padding="32px">
      <img
        src={theme.name === "dark" ? IllustrationDark : Illustration}
        alt={intl.formatMessage({ id: "teams.projects.add.title" })}
      />
      <EmptyCards.Title>
        <FormattedMessage id="teams.projects.add.title" />
      </EmptyCards.Title>
      {!props.onAdd ? (
        <Tooltip
          analyticId="teams.projects.add.button.disabled"
          tooltip={<FormattedMessage id="teams.projects.add.button.disabled" />}
        >
          <AddButton disabled analyticId="teams.projects.add.button">
            <FormattedMessage id="teams.projects.add.button" />
          </AddButton>
        </Tooltip>
      ) : (
        <AddButton onClick={props.onAdd} analyticId="teams.projects.add.button">
          <FormattedMessage id="teams.projects.add.button" />
        </AddButton>
      )}
    </EmptyCards.Card>
  );
};
